import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[toggleValidate]'
})
export class ToggleValidateDirective {

  private _shown = false;

  constructor(private el: ElementRef) {
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.right = '3%';
    // span.style.bottom = '20%';
    span.style.top = '4%'; 
    span.style.zIndex = '99'; 
    span.innerHTML = '<i class="fa fa-eye-slash">';
    span.addEventListener('click', () => {
      this.toggle(span);
    });
    parent.appendChild(span);
  }

  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      // span.innerHTML = 'hide';
      span.innerHTML = '<i class="fa fa-eye">';
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      // span.innerHTML = 'show';
      span.innerHTML = '<i class="fa fa-eye-slash">';
      
    }
  }
}